// core version + navigation, pagination modules:
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Navigation, Pagination } from 'swiper/modules';

const swipers = document.querySelectorAll('.quotes-swiper');

if (swipers.length) {
    // init Swiper:
    const swiper = new Swiper('.quotes-swiper', {
        // configure Swiper to use modules
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: "[data-quotes-next]",
            prevEl: "[data-quotes-prev]",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            bulletElement: 'button',
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
            1024: {
                slidesPerView: 2,
                spaceBetween: 16,
            }
        }
    });
}

const gallerySwipers = document.querySelectorAll('.gallery');

if (gallerySwipers.length) {
    gallerySwipers.forEach((swiperElement) => {
        const createSwiper = () => {
            const slideElements = swiperElement.querySelectorAll('.swiper-slide');
            if (!slideElements.length) {
                return;
            }
            const useLooping = slideElements.length > 3 ? true : false;
            const swiper = new Swiper(swiperElement, {
                modules: [Navigation],
                navigation: {
                    nextEl: ".swipe__navigation--next",
                    prevEl: ".swipe__navigation--prev",
                },
                loop: useLooping,
                // lazy: true,
                slidesPerView: "auto",
                grabCursor: true,
                centeredSlides: useLooping,
                initialSlide: 0,
                loopAdditionalSlides: 3,
                on: {
                    afterInit: function (swiper) {
                        swiper.slideToLoop(0);
                    }
                }
            });
            const videos = swiperElement.querySelectorAll('[data-video]');
            videos.forEach((video) => {
                video.addEventListener('click', (e) => {
                    const videoId = e.target.dataset.video;
                    const videoSource = e.target.dataset.source;
                    const embedUrl = (videoSource === 'vimeo') ? 'player.vimeo.com/video' : 'www.youtube.com/embed';
                    const galleryParent = video.closest('.gallery__container');
                    const embedHolder = galleryParent.querySelector('[data-embed-content]');
                    const embedContainer = galleryParent.querySelector('.gallery__embed');
                    const embedContent = `<iframe allow="autoplay" src="https://${embedUrl}/${videoId}?autoplay=1" allowfullscreen></iframe>`;
                    embedHolder.innerHTML = embedContent;
                    embedContainer.classList.add('gallery__embed--active');

                    const textContainer = swiperElement.closest('.accordion__text');
                    if (textContainer) {
                        textContainer.classList.add('accordion__text--embed-active');
                    }

                    const galleryClose = galleryParent.querySelector('[data-embed-close]');

                    const closeVideo = (e) => {
                        if (textContainer) {
                            textContainer.classList.remove('accordion__text--embed-active');
                        }
                        embedContainer.classList.remove('gallery__embed--active');
                        galleryClose.removeEventListener('click', closeVideo);
                        embedHolder.innerHTML = '';
                    };
                    galleryClose.addEventListener('click', closeVideo);
                });
            });
        };
        const accordionParent = swiperElement.closest('.accordion__item');
        let swiperInit = false;
        if (accordionParent) {
            if (('#' + accordionParent.id) === location.hash) {
                // The swiper is inside an open accordion, initialize directly
                createSwiper();
                swiperInit = true;
            } else {
                // The swiper is inside a closed accordion. We need to tell the swiper to update when
                // the accordion opens, or we will miss the "loop slides" at the beginning
                accordionParent.querySelector('.accordion__title').addEventListener('click', (e) => {
                    if (!swiperInit) {
                        createSwiper();
                        swiperInit = true;
                    }
                });
            }
        } else {
            createSwiper();
            swiperInit = true;
        }
    });
}

const accomodationSwipers = document.querySelectorAll('.accomodations-swiper');

if (accomodationSwipers.length) {
    const swiper = new Swiper('.accomodations-swiper', {
        modules: [Navigation],
        navigation: {
            nextEl: ".swipe__navigation--next",
            prevEl: ".swipe__navigation--prev",
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 16
    });
}